var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"perf-card"},[_c('div',{staticClass:"perf-card__date",domProps:{"innerHTML":_vm._s(_vm.date)}}),_c('div',{staticClass:"perf-card__content"},[_c('h3',{staticClass:"perf-card__type",domProps:{"innerHTML":_vm._s(_vm.type)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }